import { useQueryClient } from '@tanstack/react-query'
import { getCookie } from 'common/utils/utils';
import { QUERIES_KEYS } from 'constant';
import { APP_CONSTANTS } from 'constants/app';
import { FEATURE_FLAGS_KEYS } from 'constants/featureFlags';
import { openChatbot } from 'features/loggedInRoutesPanel/slice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { selectConfigData } from 'remote-state/aiConfigDataHook';
import { AGENT_CHATBOT_ID, CHATBOT_CONFIGS } from 'remote-state/chatbotHook';
import { getApplicationData } from 'services/applicationService';
import { getFlagValue } from 'services/featureFlagsService';
import { getAIConfigData, getChatbotConfigs } from 'services/sysaiService';

export const useInitializeChatbotOpen = () => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    useEffect(() => {

        const initializeChatbotOpen = async () => {
            const localStorageChatbotClosed = localStorage.getItem(APP_CONSTANTS.IS_CHATBOT_CLOSED) === 'true';
        
            if (localStorageChatbotClosed) {
              // Close only on first render if user chose to close it by default
              dispatch(openChatbot(false));
              return;
            }
            
            const sessionId = getCookie(APP_CONSTANTS.SESSION_ID);

            if (!sessionId) {
                return;
            }
    
            const { isAiEnabled } = await queryClient.fetchQuery({
                queryKey: [QUERIES_KEYS.APPLICATION_DATA],
                queryFn: getApplicationData,
            });
    
            if (!isAiEnabled) {
                return;
            }
    
            const flagKey = FEATURE_FLAGS_KEYS.ADMIN_CHATBOT_ENABLED;
            const accountId = localStorage.getItem(APP_CONSTANTS.ACCOUNT_ID_LOCAL_KEY);
    
            const isAdminChatbotEnabled = await queryClient.fetchQuery({
                  queryKey: [QUERIES_KEYS.FEATURE_FLAG, { accountId, flagKey }],
                  queryFn: () => getFlagValue({ flagKey, accountId, defaultValue: false }).catch(() => false),
            });
    
            if (!isAdminChatbotEnabled) {
                return;
            }
    
            const aiConfigData = await queryClient.fetchQuery({
                queryKey: [QUERIES_KEYS.AI_CONFIG_DATA],
                queryFn: getAIConfigData,
            });
    
            const copilotPlanFlags = selectConfigData(aiConfigData, QUERIES_KEYS.COPILOT_PLAN_FLAGS);
    
            if (!copilotPlanFlags?.copilotForAgentsEnabled) {
                return;
            }
    
            const isAiAdministrator = selectConfigData(aiConfigData, QUERIES_KEYS.IS_AI_ADMINISTRATOR);
    
            const chatbotConfigs = await queryClient.fetchQuery({
                queryKey: [CHATBOT_CONFIGS],
                queryFn: getChatbotConfigs,
            });
    
            const agentChatbot = chatbotConfigs.chatbots.find(chatbot => chatbot.id === AGENT_CHATBOT_ID);
    
            dispatch(openChatbot(isAiAdministrator || agentChatbot?.configuration?.isChatbotEnable))
        }

        initializeChatbotOpen();

    }, [dispatch, queryClient])
}